import { Navigate, useSearchParams } from 'react-router-dom';
import { useActiveBusiness } from '../../app/ActiveBusinessLayout.js';
import { needsOnboarding } from '../onboarding/index.js';

/**
 * `/subscribe` and `/subscribe/done` — retired pages, kept as redirects.
 *
 * Subscribing now happens where the owner already is: the wizard's Activate
 * step while in setup, Settings › Billing afterwards. Stripe returns there
 * directly (`createCheckoutSession`). These paths stay for bookmarks, old
 * links and Checkout sessions opened before the change, so a payment never
 * returns to a missing page: `session_id` and `canceled` travel along, and
 * the destination confirms the payment itself (`useCheckoutReturn`).
 */
export function SubscribeRedirect() {
  const business = useActiveBusiness();
  const [params] = useSearchParams();
  const carry = new URLSearchParams();
  for (const key of ['session_id', 'canceled']) {
    const value = params.get(key);
    if (value) carry.set(key, value);
  }
  const target = needsOnboarding(business)
    ? new URLSearchParams({ step: 'plan' })
    : new URLSearchParams({ section: 'billing' });
  carry.forEach((value, key) => target.set(key, value));
  const path = needsOnboarding(business) ? 'setup' : 'settings';
  return <Navigate to={`/b/${business.id}/${path}?${target}`} replace />;
}
